import * as React from "react";
import Helpers from "../../../gulp/scripts/typescript/modules/helpers";
import Logger from "../../../gulp/scripts/typescript/modules/logger";
import WishlistContext from "../../../wishlistsrc/src/services/WishlistContext";
import WishlistService from "../../../wishlistsrc/src/services/WishlistService";
import { ILineItem } from "../models/ILineItem.model";
import BasketContext from "../services/BasketContext";
import BasketService from "../services/BasketService";
import NotificationType from "./notification/NotificationType";
import useNotification from "./notification/useNotification";
import QuantityPicker from "./QuantityPicker";
import RetailPrice from "./RetailPrice";
import TradePrice from "./TradePrice";
import WishlistProductExistsPopup from "./WishlistProductExistsPopup";
declare var Tooltip: any;
declare var AddToBasketOverlay: any;
declare var addProduct: any;
declare var dataLayer: any;
declare var addedProducts: any;
declare global {
	interface Window { addedProducts: any; }
}

function LineItem(props: ILineItem) {

	const [isLoading, setIsLoading] = React.useState(false);
	const [showWishlistProductExistsPopup, setShowWishlistProductExistsPopup] = React.useState(false);
	const isSample = props.IsSample;
	const { addNotification } = useNotification();
	const basketContext = React.useContext(BasketContext);
	const wishlistContext = React.useContext(WishlistContext);
	const basketService = new BasketService();
	const wishlistService = new WishlistService();

	React.useEffect(() => {

		if (typeof Tooltip != "undefined" && props.HasRecommendedExtras) {
			Tooltip.init(false);
		}

	}, []);

	async function handleMoveLineItemToWishlist(e: React.MouseEvent, lineItem: ILineItem) {
		setIsLoading(true);
		let productIsInWishlist = false;

		try {
			productIsInWishlist = await checkProductExistsInWishlist(lineItem);
		} catch (error) {
			Logger.trackException(error, 'Unknown error checking if product is in wishlist');
		}

		if (productIsInWishlist) {
			setIsLoading(false);

			return;
		} else {
			await moveLineItemToWishlist(lineItem);
		}
	}

	async function moveLineItemToWishlist(lineItem: ILineItem, overrideQuantity: boolean = false) {
		let moveLineItemToWishlistResponse: any;
		try {
			moveLineItemToWishlistResponse = await basketService.moveLineItemToWishlist(lineItem.Guid, lineItem.Quantity, overrideQuantity);
			if (moveLineItemToWishlistResponse._embedded) {
				basketContext.setBasket(moveLineItemToWishlistResponse._embedded.basket);
				wishlistContext.setWishlist(moveLineItemToWishlistResponse._embedded.wishlist);
				const updateWishlistSummaryCount = Helpers.createCustomEventForDispatch('updateWishlistSummaryCount', {
					count: moveLineItemToWishlistResponse._embedded.wishlist.TotalItemQuantity
				});
				document.dispatchEvent(updateWishlistSummaryCount);
				wishlistService.trackMoveToWishlistFromBasket(lineItem);
			} else if (moveLineItemToWishlistResponse.Message) {
				addNotification({
					headline: moveLineItemToWishlistResponse.Message,
					type: NotificationType.error
				});
			}
		} catch (error) {
			addNotification({
				headline: "An unexpected error occurred when trying to move your item to the wishlist. Please try again later.",
				type: NotificationType.error
			});
			handleClosePopup();
			Logger.trackException(error, 'Unknown error moving line item to wishlist');
		} finally {
			setIsLoading(false);
		}
	}

	async function checkProductExistsInWishlist(lineItem: ILineItem) {
		let wishlistResponse = await wishlistService.getWishlist();

		if (wishlistResponse.Products) {
			for (let i = 0; i < wishlistResponse.Products.length; i++) {
				if (wishlistResponse.Products[i].Product.Guid === lineItem.ProductGuid) {
					setShowWishlistProductExistsPopup(true);
					return true;
				}
			}
		}

		return false;
	}

	function handleRemoveLineItem(e: React.MouseEvent, lineItem: ILineItem) {

		setIsLoading(true);
		basketService.removeLineItem(lineItem.Guid).then((data) => {
			setIsLoading(false);
			basketContext.setBasket(data._embedded.basket);

			if (!window.addedProducts) {
				window.addedProducts = [];
			}
			for (let i = 0; i < window.addedProducts.length; i++) {
				if (window.addedProducts[i].id === lineItem.ProductName || window.addedProducts[i].sku === lineItem.ProductName) {
					window.addedProducts.splice(i, 1);
					break;
				}
			}

			lineItem.ViewItemEventInfo.quantity = lineItem.Quantity;

			dataLayer.push({ ecommerce: null });
			dataLayer.push({
				event: 'remove_from_cart',
				ecommerce: {
					value: lineItem.Price.Price,
					items: [ lineItem.ViewItemEventInfo ]
				}
			});

		})
			.catch((error: Error) => {
				setIsLoading(false);
				addNotification({
					headline: 'An error has occurred trying to remove this item. Please try again.',
					type: NotificationType.error
				});
				Logger.trackException(error, 'Unknown error removing line item from basket');
			});
	}

	function showRecommmendedExtras(e: React.MouseEvent) {
		setIsLoading(true);
		basketService.getRecommendedExtras(props.ProductName).then((response) => {
			const recommendedExtrasForProduct = response;
			updateAddedProducts(recommendedExtrasForProduct.RecommendedExtras);
			const addToBasketOverlay = new AddToBasketOverlay();
			addToBasketOverlay.open(recommendedExtrasForProduct);
			setIsLoading(false);
		})
			.catch((error: Error) => {
				setIsLoading(false);
				addNotification({
					headline: 'An error has occurred trying to get recommended extras. Please try again.',
					type: NotificationType.error
				});
				Logger.trackException(error, 'Unknown error getting recommended extras');
			});
	}

	function updateAddedProducts(recommendedExtras: any) {
		if (!window.addedProducts) {
			window.addedProducts = [];
		}
		for (let i = 0; i < recommendedExtras.length; i++) {
			const recommendedExtra = recommendedExtras[i];
			const found = window.addedProducts.find((product) => product.id === recommendedExtra.Id);
			if (found) {
				for (let i = 0; i < window.addedProducts.length; i++) {
					if (window.addedProducts[i].id === recommendedExtra.Id) {
						window.addedProducts[i].quantity = recommendedExtra.Quantity;
						break;
					}
				}
			} else {
				window.addedProducts.push({
					id: recommendedExtra.Id,
					sku: recommendedExtra.Id,
					quantity: recommendedExtra.Quantity,
					price: recommendedExtra.Price.Price
				});
			}
		}
	}

	function handleClosePopup() {
		setShowWishlistProductExistsPopup(false);
	}

	return (
		<React.Fragment>
			{showWishlistProductExistsPopup ?
				<WishlistProductExistsPopup overwriteWishlistProduct={() => moveLineItemToWishlist(props, true)} combineWishlistProducts={() => moveLineItemToWishlist(props, false)} handleClose={handleClosePopup} />
				: null}
			<div className={`c-basket__item ${isLoading ? 'c-basket__item--loading' : ''} ${basketContext.basket.IsTradeCustomer ? 'c-basket__item--trade' : ''}`} data-test="basket-product-item" data-test-product-id={props.ProductName}>

				<div className="c-basket__item-thumbnail">
					{isSample
						? <picture className="picture">
							<source srcSet={`${props.ProductImageBaseUrl}/${props.ProductImage.ImagePath}?w=190&amp;h=190&amp;mode=crop&amp;format=webp&amp;quality=80`} type="image/webp" />
							<img src={`${props.ProductImageBaseUrl}/${props.ProductImage.ImagePath}?w=190&amp;h=190&amp;mode=crop&amp;quality=80`} alt={props.ProductImage.Alt} className="inner" loading="lazy" width={190} height={190} />
						</picture>
						: <a className="c-basket__item-thumbnail-link" href={`/p/${props.ProductName}`} data-test="basket-item-image-link">
							<picture className="picture">
								<source srcSet={`${props.ProductImageBaseUrl}/${props.ProductImage.ImagePath}?w=190&amp;h=190&amp;mode=crop&amp;format=webp&amp;quality=80`} type="image/webp" />
								<img src={`${props.ProductImageBaseUrl}/${props.ProductImage.ImagePath}?w=190&amp;h=190&amp;mode=crop&amp;quality=80`} alt={props.ProductImage.Alt} className="inner" loading="lazy" width={190} height={190} />
							</picture>
						</a>
					}
				</div>

				<div className="c-basket__item-middle">
					{isSample
						? <span className="c-basket__item-title" data-test="basket-product-name">{props.DisplayName}</span>
						: <a className="c-basket__item-title" href={`/p/${props.ProductName}`} data-test="basket-product-name">{props.DisplayName}</a>
					}

					<p className="c-basket__item-delivery" data-test="delivery-message">{props.StockMessage}</p>
					{
						props.Variant ?
							<p className="c-basket__item-delivery">Option selected: {props.Variant}</p>
							: null
					}

					<div className="c-basket__item-discounts">
						{
							props.Discounts.map((discount, index) => {
								return <p className="c-basket__item-discount" key={discount.DiscountId} data-test="basket-line-item-discount">Discount code: {discount.Description} {discount.Amount.Formatted}</p>
							})
						}
					</div>

					{
						props.HasRecommendedExtras ?
							<div className="c-basket__item-recommended-container">
								<button type="button" className="c-basket__item-recommended c-basket__item-link" onClick={(e) => showRecommmendedExtras(e)} data-test={`recommended-extras-link-${props.ProductName}`}>Add <span className="noMobile">recommended</span> extras</button>
								<span className="js-tooltip-trigger-wrapper js-tooltip-trigger-wrapper--right">
									<a className="js-tooltip-trigger" href={`#recommendedExtrasTooltip-${props.Guid}`} data-js-tooltip-trigger data-js-tooltip-trigger-position="bottom" data-js-tooltip-hide-dimmer="true" data-test={`recommended-extras-tooltip-button-${props.ProductName}`}>
										<tooltip-trigger-icon />
										<span className="u-visuallyhidden">Help?</span>
									</a>
								</span>
								<div className="js-tooltip" id={`recommendedExtrasTooltip-${props.Guid}`} data-js-tooltip data-test={`recommended-extras-tooltip-${props.ProductName}`}>
									<div className="js-tooltip__inner js-tooltip__inner--delivery js-tooltip__inner--font-normal" data-js-tooltip-inner>
										<div className="cms">
											<p>We've hand-picked these items because they go well with the {props.DisplayName}.</p>
											<p>Some of these items are essential for the installation of your product - please check with our team if you need help choosing.</p>
										</div>
									</div>
								</div>
							</div>
							: null}

				</div>

				<div className="c-basket__item-end">

					{isSample
						? <p className="c-add-product__label">Quantity: {props.Quantity}</p>
						: <QuantityPicker {...props} setLoading={setIsLoading} isLoading={isLoading} />}

					<div className="c-basket__price-container">
						{basketContext.basket.IsTradeCustomer ?
							<TradePrice {...props}></TradePrice>
						:
							<RetailPrice {...props}></RetailPrice>
						}

					</div>

					<p className="c-basket__actions">
						{!isSample && (
							<>
								<span className="c-basket__move-to-wishlist">
									<button className="c-basket__item-link" onClick={(e) => handleMoveLineItemToWishlist(e, props)} data-test="basket-line-item-move-to-wishlist-button">Move to wishlist</button>
								</span>
								<span className="c-basket__actions__divider" />
							</>
						)}
						<span className="c-basket__remove">
							<button className="c-basket__item-link" type="button" data-test={`basket-line-item-remove-${props.ProductName}`} onClick={(e) => handleRemoveLineItem(e, props)}>Remove from basket</button>
						</span>
						</p>
				</div>

			</div>
		</React.Fragment>
	);


}

export default LineItem;
